<template>
  <div class="table">
    <qx-table :data="list" @selection-change="onSelection" @sort-change="sortChange" stripe>
      <template v-for="config in configs">
        <el-table-column v-if="config.prop === 'operation'" v-bind="columnBind(config)" :key="`${config.prop}-operation`">
          <template scope="scope">
            <qx-btn @click="onClick('edit', scope.row)">编辑(Edit)</qx-btn>
          </template>
        </el-table-column>

        <el-table-column
            v-else-if="config.headerTooltip"
            v-bind="columnBind(config)"
            :key="`${config.prop}-tooltip`"
            :sortable="config.sortable">
          <template slot="header">
            <span class="table-column-header-with-help">
              <span>{{ config.label }}</span>
            <el-tooltip :content="config.headerTooltip" placement="top">
              <span class="table-column-header-help">?</span>
            </el-tooltip>
            </span>
          </template>
        </el-table-column>

        <el-table-column v-else v-bind="columnBind(config)" :key="`${config.prop}-normal`" :sortable="config.sortable"></el-table-column>
      </template>
    </qx-table>
  </div>
</template>

<script>
import QxTable from "@/components/common/qx-table";
import QxBtn from "@/components/common/qx-btn";
import QxLink from "@/components/common/qx-link";

export default {
  name: "BaseTable",
  components: {QxLink, QxBtn, QxTable},
  props: {
    list: Array,
    configs: Array,
  },
  data: function () {
    return {}
  },
  computed: {},
  methods: {
    columnBind: function (config) {
      const bind = Object.assign({}, config)
      delete bind.headerTooltip
      return bind
    },
    selectable: function (row) {
      return _.has(row.operation, "audit") && !_.isEmpty(row.operation.audit)
    },
    operations: function (op) {
      if (_.has(op, "audit") && _.isEmpty(op['audit'])) {
        delete op.audit
      }
      return _.keys(op)
    },
    onClick: function (op, item) {
      this.$emit('operation', {name: op, item: item});
    },
    onSelection: function (val) {
      this.$emit("selection", val)
    },
    sortChange: function (column) {
      this.$emit("sortChange", column)
    }
  }
}
</script>

<style scoped>
.table {
  margin-top: 20px;
}

.table >>> .expand {
  padding-left: 47px;
}

.table >>> .el-table__expanded-cell {
  padding: 0;
}

.table >>> .expand .el-table--border {
  border-top: none;
}

.table-column-header-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #c0c4cc;
  color: #ffffff;
  font-size: 10px;
  line-height: 13px;
  font-weight: 500;
  cursor: help;
  margin-left: 4px;
}

.table-column-header-with-help {
  display: inline-flex;
  align-items: center;
}
</style>
